<template>
  <div class="app-container">
    <div class="tb" style="height: 100%">
      <div class="main tb">
        <div class="lr between">
          <div style="display: flex;justify-content: space-between;">
            <el-input v-model="table.query.keyWord" placeholder="请输入关键字查询" clearable
                      suffix-icon="el-icon-search" @change="search(true)"/>
          </div>
          <div style="display: flex;justify-content: flex-end;" v-if="showButton">
            <el-button type="primary" size="small" @click="openDialog(null, false)"
                       icon="el-icon-plus">新增
            </el-button>
          </div>
        </div>
        <div class="main" style="margin-top: 20px;">
          <el-table :data="table.data" height="600px" border
                    :header-cell-style="{background:'#fafafa',color:'#000000'}" v-loading="tableLoading">
            <el-table-column show-overflow-tooltip fixed="left" label="序号" type="index" width="55"
                             align="center"/>
            <el-table-column show-overflow-tooltip label="小区" align="center"
                             prop="communityName"></el-table-column>
            <el-table-column show-overflow-tooltip label="房源" align="center"
                             prop="houseName"></el-table-column>
            <el-table-column show-overflow-tooltip label="管理员" align="center"
                             prop="adminName"></el-table-column>
            <el-table-column show-overflow-tooltip label="付款方式" align="center"
                             prop="payType">
              <template slot-scope="scope">
                <span v-if="scope.row.payType == 0">月付</span>
                <span v-if="scope.row.payType == 1">季付</span>
                <span v-if="scope.row.payType == 2">半年付</span>
                <span v-if="scope.row.payType == 3">年付</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="押金" align="center"
                             prop="deposit"></el-table-column>
            <el-table-column show-overflow-tooltip label="支出中介费" align="center"
                             prop="agencyFee"></el-table-column>
            <el-table-column show-overflow-tooltip label="月租金" align="center"
                             prop="rent"></el-table-column>
            <el-table-column show-overflow-tooltip label="应付租金" align="center"
                             prop="rent">
              <template slot-scope="scope">
                <span v-if="scope.row.payType == 0">{{scope.row.rent}}</span>
                <span v-if="scope.row.payType == 1">{{Math.ceil(scope.row.rent) * 3}}</span>
                <span v-if="scope.row.payType == 2">{{Math.ceil(scope.row.rent) * 6}}</span>
                <span v-if="scope.row.payType == 3">{{Math.ceil(scope.row.rent) * 12}}</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="开始日期" align="center"
                             prop="startDate"></el-table-column>
            <el-table-column show-overflow-tooltip label="结束日期" align="center"
                             prop="endDate"></el-table-column>
            <el-table-column show-overflow-tooltip label="实际结束日期" align="center"
                             prop="actualEndDate"></el-table-column>
            <el-table-column show-overflow-tooltip label="首次交租日期" align="center"
                             prop="firstRentDate"></el-table-column>
<!--            <el-table-column show-overflow-tooltip label="合同日期" align="center"-->
<!--                             prop="contractDate"></el-table-column>-->
            <el-table-column show-overflow-tooltip label="备注" align="center"
                             prop="description"></el-table-column>
            <el-table-column show-overflow-tooltip label="操作" width="260" align="center" v-if="showButton">
              <template slot-scope="scope">
<!--                <el-button type="text" @click="openDialog(scope.row, true)">编辑</el-button>-->
                <el-button type="text" @click="toDetail(scope.row)">明细</el-button>
                <el-button type="text" @click="openBillDialog(scope.row)">账单</el-button>
                <el-button type="text" style="color: #ff4949;" @click="deleteData(scope.row.id)">删除</el-button>
                <el-button type="text" style="color: #ff4949;" @click="endContract(scope.row)" v-if="!scope.row.isEnd">结束合同</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="lr end" style="margin-top: 20px;">
          <el-pagination :total="table.total" :page-size="table.query.size" :current-page="table.query.page"
                         layout="total, prev, pager, next" @current-change="currentPageChange"/>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="ownerRentRecordDialog.visible" :close-on-click-modal="false" width="40%"
               :title="!isEdit ? '新增房东交租记录' : '编辑房东交租记录'">
      <el-form ref="ownerRentRecordForm" label-position="right" label-width="120px" :model="ownerRentRecordDialog.formData"
               :rules="rules" style="height: 500px;overflow-y: auto;padding: 0 20px;">
        <el-form-item label="房源：" prop="houseId">
          <el-select disabled filterable  v-model="ownerRentRecordDialog.formData.houseId" placeholder="请选择房源" clearable style="width: 100%;">
            <el-option v-for="item in houses" :key="item.id" :value="item.id"
                       :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="管理员：" prop="adminId">
          <el-select filterable  v-model="ownerRentRecordDialog.formData.adminId" placeholder="请选择管理员" clearable style="width: 100%;">
            <el-option v-for="item in admins" :key="item.id" :value="item.id"
                       :label="item.nickname"></el-option>
          </el-select>
        </el-form-item>
<!--        <el-form-item label="主题：" prop="title">-->
<!--          <el-input placeholder="请输入主题" v-model="ownerRentRecordDialog.formData.title" clearable/>-->
<!--        </el-form-item>-->
        <el-form-item label="付款方式：" prop="payType">
          <el-select filterable  v-model="ownerRentRecordDialog.formData.payType" placeholder="请选择付款方式" clearable style="width: 100%;">
            <el-option v-for="item in payTypes" :key="item.id" :value="item.id"
                       :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="租金：" prop="rent">
          <el-input-number :precision="2" :step="0.1" :min="0" style="width: 100%" v-model="ownerRentRecordDialog.formData.rent"
                           clearable/>
        </el-form-item>
        <el-form-item label="押金：" prop="deposit">
          <el-input-number :precision="2" :step="0.1" :min="0" style="width: 100%" v-model="ownerRentRecordDialog.formData.deposit"
                           clearable/>
        </el-form-item>
        <el-form-item label="支出中介费：" prop="agencyFee">
          <el-input-number :precision="2" :step="0.1" :min="0" style="width: 100%" v-model="ownerRentRecordDialog.formData.agencyFee"
                           clearable/>
        </el-form-item>
        <el-form-item label="开始日期：" prop="startDate">
          <el-date-picker
            v-model="ownerRentRecordDialog.formData.startDate"
            type="date"
            placeholder="请选择开始日期"
            value-format="yyyy-MM-dd"
            style="width: 100%;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期：" prop="endDate">
          <el-date-picker
            v-model="ownerRentRecordDialog.formData.endDate"
            type="date"
            placeholder="请选择结束日期"
            value-format="yyyy-MM-dd"
            style="width: 100%;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="首次交租日期：" prop="firstRentDate">
          <el-date-picker
            v-model="ownerRentRecordDialog.formData.firstRentDate"
            type="date"
            placeholder="请选择首次收租日期"
            value-format="yyyy-MM-dd"
            style="width: 100%;">
          </el-date-picker>
        </el-form-item>
<!--        <el-form-item label="合同日期：" prop="contractDate">-->
<!--          <el-date-picker-->
<!--            v-model="ownerRentRecordDialog.formData.contractDate"-->
<!--            type="date"-->
<!--            placeholder="请选择合同日期"-->
<!--            value-format="yyyy-MM-dd"-->
<!--            style="width: 100%;">-->
<!--          </el-date-picker>-->
<!--        </el-form-item>-->
        <el-form-item label="合同照片：">
          <el-upload
            action="/group1/upload?output=json"
            list-type="picture-card"
            :file-list="fileList"
            :on-success="handleSuccess"
            :on-remove="handleRemove"
            accept="image/gif,image/jpeg,image/png,.gif,.jpeg,.jpg,.png">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="备注：" prop="description">
          <el-input type="textarea" :rows="3" placeholder="请输入备注" v-model="ownerRentRecordDialog.formData.description"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-btn">
        <el-button @click="ownerRentRecordDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="saveOrUpdateData" :loading="loading">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="billDialog.visible" :close-on-click-modal="false" width="50%"
               title="账单">
      <el-table :data="billDialog.data" height="450px" border
                :header-cell-style="{background:'#fafafa',color:'#000000'}" v-loading="billDialog.tableLoading">
        <el-table-column show-overflow-tooltip fixed="left" label="序号" type="index" width="55"
                         align="center"/>
        <el-table-column show-overflow-tooltip label="房源名" align="center"
                         prop="houseName"></el-table-column>
        <el-table-column show-overflow-tooltip label="月租金" align="center"
                         prop="rent"></el-table-column>
        <el-table-column show-overflow-tooltip label="应付租金" align="center"
                         prop="rent">
          <template slot-scope="scope">
            <span v-if="scope.row.payType == 0">{{scope.row.rent}}</span>
            <span v-if="scope.row.payType == 1">{{Math.ceil(scope.row.rent) * 3}}</span>
            <span v-if="scope.row.payType == 2">{{Math.ceil(scope.row.rent) * 6}}</span>
            <span v-if="scope.row.payType == 3">{{Math.ceil(scope.row.rent) * 12}}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="付款方式" align="center"
                         prop="payType">
          <template slot-scope="scope">
            <span v-if="scope.row.payType == 0">月付</span>
            <span v-if="scope.row.payType == 1">季付</span>
            <span v-if="scope.row.payType == 2">半年付</span>
            <span v-if="scope.row.payType == 3">年付</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="应交租日期" align="center"
                         prop="needRentDate"></el-table-column>
        <el-table-column show-overflow-tooltip label="状态" align="center"
                         prop="state">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 0">未交租</span>
            <span v-if="scope.row.state == 1">已交租</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog :visible.sync="endDialog.visible" :close-on-click-modal="false" width="30%"
               title="结束合同">
      <el-form ref="ownerRentRecordForm" label-position="right" label-width="120px" :model="endDialog.formData"
               :rules="endRules" style="padding: 0 20px;">
        <el-form-item label="结束日期：" prop="endContractDate">
          <el-date-picker
            v-model="endDialog.formData.endContractDate"
            type="date"
            placeholder="请选择结束日期"
            value-format="yyyy-MM-dd"
            style="width: 100%;">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="dialog-btn">
        <el-button @click="endDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="endContract">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

import {getPageList, deleteData, saveOrUpdateData, checkPrevious, endRentRecord} from "@/api/ownerRentRecord";
import {getList} from "@/api/ownerCollectRecord";
import {getList as getAdmins} from "@/api/user";

export default {
  props: {
    houses: {
      type:Array,
      default: () => []
    },
    houseId: {
      type: Number,
      default: 0
    },
    nowContractId: {
      type: Number,
      default: 0
    },
    showButton: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      table: {
        query: {
          page: 1,
          size: 10,
          keyWord: '',
          houseId: ''
        },
        total: 0,
        data: []
      },
      ownerRentRecordDialog: {
        formData: {
          houseId: '',
          hoseName: '',
          adminId: '',
          adminName: '',
          payType: 0,
          state: 0,
          deposit: 0,
          agencyFee: 0,
          rent: 0,
          startDate: '',
          endDate: '',
          firstRentDate: '',
          contractDate: '',
          imageUrls: '',
          description: ''
        },
        visible: false
      },
      billDialog: {
        data: [],
        visible: false,
        tableLoading: false
      },
      endRules: {
        endContractDate: [
          {trigger: 'blur', required: true, message: '请选择结束日期'}
        ]
      },
      rules: {
        houseId: [
          {trigger: 'change', required: true, message: '请选择房源'}
        ],
        adminId: [
          {trigger: 'change', required: true, message: '请选择管理员'}
        ],
        title: [
          {trigger: 'change', required: true, message: '请输入主题'}
        ],
        payType: [
          {trigger: 'blur', required: true, message: '请选择付款方式'}
        ],
        deposit: [
          {trigger: 'blur', required: true, message: '请输入押金'}
        ],
        agencyFee: [
          {trigger: 'blur', required: true, message: '请输入支出中介费'}
        ],
        rent: [
          {trigger: 'blur', required: true, message: '请输入租金'}
        ],
        startDate: [
          {trigger: 'blur', required: true, message: '请选择开始日期'}
        ],
        endDate: [
          {trigger: 'blur', required: true, message: '请选择结束日期'}
        ],
        firstRentDate: [
          {trigger: 'blur', required: true, message: '请选择首次收租日期'}
        ],
        contractDate: [
          {trigger: 'blur', required: true, message: '请选择合同日期'}
        ],
        imageUrls: [
          {trigger: 'blur', required: true, message: '请上传证件照片'}
        ]
      },
      breakDialog: {
        formData: {
          houseId: '',
          roomName: '',
          payType: 0,
          deposit: 0,
          rent: 0,
          startDate: '',
          endDate: '',
          firstRentDate: '',
          contractDate: '',
          description: ''
        },
        visible: false
      },
      endDialog: {
        formData: {
        },
        visible: false
      },
      loading: false,
      tableLoading: false,
      isEdit: false,
      payTypes: [
        {
          id: 0,
          name: '月付'
        },
        {
          id: 1,
          name: '季付'
        },
        {
          id: 2,
          name: '半年付'
        },
        {
          id: 3,
          name: '年付'
        }
      ],
      oldPayType: 0,
      fileList: [],
      admins: []
    }
  },
  mounted() {
    if (this.houseId) {
      this.table.query.houseId = this.houseId
      this.ownerRentRecordDialog.formData.houseId = this.houseId
    }
    this.search(true)
    this.getAdmins()
  },
  methods: {
    toDetail(row) {
      this.$router.push('/houseOwnerDetail?houseId=' + row.houseId + '&ownerRentRecordId=' + row.id)
    },
    getAdmins() {
      const params = {
        roleId: '2,5'
      }
      getAdmins(params).then(response => {
        if (response.code == 200) {
          // 查询成功
          this.admins = response.data
        }
      })
    },
    // 搜索框查询
    search(flag) {
      this.tableLoading = true
      if (flag) {
        this.table.query.page = 1
        this.table.query.keyWord = ''
        this.table.query.houseId = this.houseId
      }
      const params = {
        current: this.table.query.page,
        size: this.table.query.size,
        keyWord: this.table.query.keyWord,
        houseId: this.table.query.houseId,
        fromCooperateManage: !this.showButton
      }
      getPageList(params).then(response => {
        if (response.code == 200) {
          // 查询成功
          this.table.data = response.data
          this.table.total = response.count
        } else {
          // 查询失败
          this.$message.error('查询失败!')
        }
        this.tableLoading = false
      })
    },
    // 修改出租记录
    saveOrUpdateData() {
      this.loading = true
      this.$refs['ownerRentRecordForm'].validate(async (valid) => {
        if (valid) {
          this.ownerRentRecordDialog.formData.houseName = this.houses.filter(item => item.id == this.ownerRentRecordDialog.formData.houseId)[0].name
          this.ownerRentRecordDialog.formData.adminName = this.admins.filter(item => item.id == this.ownerRentRecordDialog.formData.adminId)[0].nickname
          this.ownerRentRecordDialog.formData.fromPc = true
          saveOrUpdateData(this.ownerRentRecordDialog.formData).then(response => {
            if (response.code == 200) {
              // 操作成功
              this.$message.success('操作成功!')
              this.ownerRentRecordDialog.visible = false
              this.search(false)
            } else {
              // 操作失败
              this.$message.error('操作失败!')
            }
            this.loading = false
          })
        } else {
          this.loading = false
        }
      })
    },
    // 打开弹窗
    openDialog(data, isEdit) {
      this.isEdit = isEdit
      this.fileList = []
      if (!isEdit) {
        // 校验上一个合同
        checkPrevious(this.houseId).then(response => {
          if (response.code == 200 && response.data) {
            // 重置数据
            this.ownerRentRecordDialog.formData = {
              houseId: this.houseId,
              houseName: '',
              title: '',
              payType: 0,
              deposit: 0,
              agencyFee: 0,
              rent: 0,
              startDate: '',
              endDate: '',
              firstRentDate: '',
              contractDate: '',
              imageUrls: '',
              description: ''
            }
            if (this.houseId) {
              this.ownerRentRecordDialog.formData.houseId = this.houseId
              this.oldPayType = this.ownerRentRecordDialog.formData.payType
            }
            this.ownerRentRecordDialog.visible = true
            // 清空验证信息
            this.$nextTick(() => {
              this.$refs.ownerRentRecordForm.clearValidate()
            })
          } else {
            this.$message.error('新增失败，上一合同尚未结束!')
          }
        })
      } else {
        if (data.imageUrls) {
          const imageUrls = data.imageUrls.split(',')
          for (let i = 0; i < imageUrls.length; i++) {
            this.fileList.push({
              uid: i,
              url: imageUrls[i]
            })
          }
        }
        this.ownerRentRecordDialog.formData = JSON.parse(JSON.stringify(data))
        this.ownerRentRecordDialog.visible = true
        // 清空验证信息
        this.$nextTick(() => {
          this.$refs.ownerRentRecordForm.clearValidate()
        })
      }
    },
    // 页码变更
    currentPageChange(page) {
      this.table.query.page = page
      this.search(false)
    },
    // 删除出租记录
    deleteData(id) {
      this.$confirm('此操作将永久删除房东交租记录信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteData(id).then(response => {
          if (response.code == 200) {
            // 操作成功
            this.$message.success('操作成功!')
            this.search(false)
          } else {
            // 操作失败
            this.$message.error(response.data)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    changePayType() {
      if (!this.ownerRentRecordDialog.id) {
        this.$confirm('修改支付方式，保存后将重置房东交租记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

        }).catch(() => {
          this.ownerRentRecordDialog.formData.payType = this.oldPayType
        })
      }
    },
    handleSuccess(response, file) {
      this.fileList.push({
        uid: file.uid,
        url: response.url
      })
      this.ownerRentRecordDialog.formData.imageUrls = this.fileList.map(item => item.url).join(',')
    },
    handleRemove(file) {
      this.fileList = this.fileList.filter(item => item.url != file.url)
      if (this.fileList && this.fileList.length > 0) {
        this.ownerRentRecordDialog.formData.imageUrls = this.fileList.map(item => item.url).join(',')
      } else {
        this.ownerRentRecordDialog.formData.imageUrls = ''
      }
    },
    // 打开账单弹窗
    openBillDialog(row) {
      this.billDialog.tableLoading = true
      const params = {
        ownerRentRecordId: row.id
      }
      getList(params).then(response => {
        this.billDialog.data = response.data
        this.billDialog.visible = true
        this.billDialog.tableLoading = false
      })
    },
    // 打开结束弹窗
    openEndDialog(row) {
      this.endDialog.visible = true
      this.endDialog.formData = row
    },
    endContract(row) {
      this.endDialog.formData = row
      this.$confirm('是否结束当前合同?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        endRentRecord(this.endDialog.formData).then(response => {
          if (response.code == 200) {
            // 操作成功
            this.$message.success('操作成功!')
            this.endDialog.visible = false
            this.search(false)
          } else {
            // 操作失败
            this.$message.error(response.data)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        })
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/OwnerRentRecord.vue